module.exports = __webpack_public_path__ + "static/passkey-f6c5370d1d69f8bec335c58fc9a22d74.png";